import React, { FC } from "react"
import styles from "../styles/HowToPlay.module.scss"

interface HowToPlayProps {
  toggleHowTo: () => void
}

const HowToPlay: FC<HowToPlayProps> = ({ toggleHowTo }) => {
  return (
    <div className={styles.container}>
      <div>
        <h1>How To Play:</h1>
        <button className={styles.closeBtn} onClick={toggleHowTo}>
          X
        </button>
        <div>
          This is a game to practice keeping time in your head. Click start and
          the timer will start ticking and disappear after 3 seconds. "Goal"
          shows how many seconds to count to. If you click "Now" right on the
          second, then you get the same amount of points as the seconds that
          went by. If you're over or under by 1 second, you get half points and
          if you're over a second off, you get deducted 5 points. Choose to play
          for one to three minute. Try to get the highest score! You may find
          you're better at keeping time after playing!
        </div>
      </div>
    </div>
  )
}

export default HowToPlay
